/**
 * Client for the 10-Week Roadmap document API (/api/roadmap).
 * Reads open; the save (PUT) goes through the shared code-based editor session
 * (same bearer token as Go-Live / Release Train).
 */
export interface RoadmapDoc {
  html: string
  updated_at: string | null
  updated_by: string | null
}

const BASE = "/api/roadmap"
const TOKEN_KEY = "golive-token"

const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY)
  } catch {
    return null
  }
}

async function req<T>(path: string, init?: RequestInit): Promise<T> {
  const token = getToken()
  const headers: Record<string, string> = { ...(init?.headers as Record<string, string>) }
  if (init?.body) headers["Content-Type"] = "application/json"
  if (token) headers["Authorization"] = `Bearer ${token}`
  const res = await fetch(`${BASE}${path}`, { credentials: "include", ...init, headers })
  if (!res.ok) {
    let detail = res.statusText
    try {
      detail = (await res.json()).detail ?? detail
    } catch {
      /* ignore */
    }
    const err = new Error(detail) as Error & { status: number }
    err.status = res.status
    throw err
  }
  return (await res.json()) as T
}

export const roadmap = {
  get: () => req<RoadmapDoc>(""),
  save: (html: string) => req<RoadmapDoc>("", { method: "PUT", body: JSON.stringify({ html }) }),
  reset: () => req<RoadmapDoc>("/reset", { method: "POST" }),
}
